import React from 'react';
import LetterSlidesContainer from '../components/c-letter-slides-container';

export default ({
  OpenModalBtnText,
  NextBtnText,
  BackBtnText,
  PopoverText,
  PopoverBtnText,
  MainContent,
  ShareButton,
  Heading,
  IntroText,
  BlockId,
}) => {
  return (
    <LetterSlidesContainer
      openModalBtnText={OpenModalBtnText}
      nextBtnText={NextBtnText}
      backBtnText={BackBtnText}
      popoverText={PopoverText}
      popoverBtnText={PopoverBtnText}
      mainContent={MainContent}
      shareButton={ShareButton?.[0]}
      heading={Heading}
      introText={IntroText}
      blockId={BlockId}
    />
  );
};
